//import global API
import { Api, Api3 } from "../../api/Api";

const auth = {
    namespaced: true,
    state: {
        token: localStorage.getItem('token') || '',
        user: localStorage.getItem('user') || {},
        id: localStorage.getItem('id') || null
    },
    mutations: {
        AUTH_SUCCESS(state, token, user) {
            state.token = token
            state.user = user
        },
        AUTH_USER(state, user) {
            state.user = user
        },
        AUTH_LOGOUT(state) {
            state.token = ''
            state.user = {}
        },

    },
    actions: {
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('AUTH_LOGOUT')
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                delete Api.defaults.headers.common['Authorization']
                resolve('')
            })
        },
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                Api.post('auth/login', user)

                    .then(response => {
                        const token = response.data.access_token
                        const user = response.data

                        localStorage.setItem('token', token)
                        localStorage.setItem('user', JSON.stringify(user))
                        localStorage.setItem('id', response.data.id)

                        Api.defaults.headers.common['Authorization'] = `Bearer ${token}`
                        commit('AUTH_SUCCESS', token, user)

                        resolve(response.data)
                    }).catch(error => {
                        localStorage.removeItem('token')
                        reject(error)
                    })

            })

        },
        forgotPassword(_, payload) {
            return new Promise((resolve, reject) => {
                Api3.post('/api-cms/forgot-password', payload)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 404) {
                            return Api3.post('/api-cms/auth/forgot-password', payload)
                                .then(response => resolve(response.data))
                                .catch(err => reject(err));
                        }
                        reject(error)
                    })
            })
        },
        resetPassword(_, payload) {
            return new Promise((resolve, reject) => {
                Api3.post('/api-cms/reset-password', payload)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 404) {
                            return Api3.post('/api-cms/auth/reset-password', payload)
                                .then(response => resolve(response.data))
                                .catch(err => reject(err));
                        }
                        reject(error)
                    })
            })
        },
    },
    getters: {
        isLoggedIn(state) {
            return state.token
        },
        user(state) {
            return state.user
        }
    }

}

export default auth